import { createAction } from '@reduxjs/toolkit';
import { FeatureGateType } from 'v2/components/pro/FeatureGate/FeatureGateModal/FeatureGateModal';

import WorkspaceLocationHash from '../../components/_workspace/WorkspaceLocationHash';

export const switchToTab = createAction<WorkspaceLocationHash>('sidebar/switchToTab');

export const showNewRecordingModal = createAction<boolean>('sidebar/showNewRecordingModal');
export const showInviteModal = createAction<InviteModalOpened>('sidebar/showInviteModal');
export const redirectToUsersSettings = createAction<boolean>('sidebar/redirectToUsersSettings');
export const showReferralModal = createAction<boolean>('sidebar/showReferralModal');
export const showEditProfileModal = createAction<boolean>('sidebar/showEditProfileModal');
export const showProFeatureGateModal = createAction<ProFeatureGateModalOpenedWithQueryParam>('sidebar/showProFeatureGateModal');

export type ProFeatureGateModalOpenedWithQueryParam = {
  visible: boolean;
  location?: string | null; // location query param from where the modal was opened
  featureType?: FeatureGateType; // feature query param from where the modal was opened
};

export type InviteModalOpened = {
  visible: boolean;
  location: string;
};

export interface SidebarState {
  currentTab: WorkspaceLocationHash;
  /**
     *
        Used to force showing a NewRecordingModal in the SideBar by using the "intent" query param
        (extension - cant-record.html page - "open a new tab" CTA) https://scribehow.com/workspace?intent=newrecording
     */
  shouldShowNewRecordingModal: boolean;
  shouldShowInviteModal: InviteModalOpened;
  shouldRedirectToUsersSettings: boolean;
  shouldShowReferralModal: boolean;
  shouldShowEditProfileModal: boolean;
  shouldShowProFeatureGateModal: {
    visible: boolean;
    location: string | null;
    featureType: FeatureGateType | null;
  };
}
